// THIS FILE IS AUTO GENERATED. CHECK generateColors.script.js FOR DETAILS
export const colors = {
  colorPriBlueOne: '#3699FF',
  colorPriBlueTwo: '#E1F0FF',
  colorPriBlueThree: '#187DE4',
  colorPriBlueFour: '#6993FF',
  colorSecBlueThree: '#A4A4E2',
  colorSecBlueFive: '#F5F5FB',
  colorSecBlueTwo: '#6268C4',
  colorPriOne: '#364258',
  colorPriRedOne: '#F64E60',
  colorPriRedTwo: '#FFE2E5',
  colorPriRedThree: '#EE2D41',
  colorPriRedFour: '#EC1775',
  colorOmeOne: '#F80166',
  colorOmeAlt: '#F00284',
  colorAmberOne: '#FFA11F',
  colorAmberTwo: '#FEE7DD',
  colorAmberThree: '#E05417',
  colorAmberFour: '#FFF4DE',
  colorAmberFive: '#EE9D01',
  colorOmeGreen: '#28CFA2',
  colorOmeGreenTwo: '#D7F9EF',
  colorOmeGreenThree: '#04AA77',
  colorOmePurpleOne: '#663259',
  colorOmePurpleTwo: '#F4E1F0',
  colorOmePurpleThree: '#58244B',
  colorWhite: '#FFF',
  colorGsOne: '#F8F9FB',
  colorGsTwo: '#CDD3DC',
  colorGsThree: '#6D7784',
  colorGsFour: '#EBEFF2',
  colorDisabledOne: '#B5B5C3',
  colorDisabledTwo: '#E5EAEE',
  colorMenuDark: '#1B1B28',
  colorMenuDefault: '#888C9F',
  colorMenuSection: '#4A4B68',

  colorWhiteLabelGreyOne: '#E5E5E5',
  colorWhiteLabelGreyTwo: '#A7A8BB',
  colorWhiteLabelGreyThree: '#8A8299',
  colorWhitelabelBlue: '#0089ED',
  colorWhitelabelGreen: '#6da5a4',

  colorIhh: '#00759B',
  colorIhhDark: '#005B7F',

  colorBrandGrey: '#8D8D8D',
};
